const initState = {
  user: {},
  token: '',
  isLogin: false,
  loading: false,
  userDetails: {}
}

export default initState
